import React, { useEffect } from 'react';
import { Form, Input, Col, Row } from 'antd';
import CommonServ from '../../../../services/CommonServ';

interface Iprops {
  tokCd: string[];
  compnyCd: string;
  compnyNm: string;
  accId: string;
  accNm: string;
}

const HeaderRow5 = (props: Iprops) => {
  const [form] = Form.useForm();

  //初期化処理
  useEffect(() => {
    const init = async () => {
      form.setFieldsValue({
        i_tok_cd: props.tokCd[0],
        i_tok_cd2: props.tokCd[1],
        i_compny_nm: props.compnyNm,
        i_acc_nm: props.accNm,
      });

      // APIに渡すパラメーターを設定
      var params = {
        cd1: props.tokCd[0],
        cd2: props.tokCd[1],
      };
      //得意先名取得
      CommonServ.getTokuisaki(params).then((json) => {
        form.setFieldsValue({
          i_tok_nm: json.data['nam'],
        });
      });
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // KS社員が得意先を変更できるのに対応
  useEffect(() => {
    const init = async () => {
      form.setFieldsValue({ i_tok_cd: props.tokCd[0], i_tok_cd2: props.tokCd[1] });
      // APIに渡すパラメーターを設定
      var params = {
        cd1: props.tokCd[0],
        cd2: props.tokCd[1],
      };
      //得意先名取得
      CommonServ.getTokuisaki(params).then((json) => {
        form.setFieldsValue({
          i_tok_nm: json.data['nam'],
        });
      });
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.tokCd]);

  return (
    <Form form={form}>
      <Row
        style={{
          backgroundColor: '#69c0ff',
          height: '50px',
          paddingTop: '8px',
        }}
      >
        <Col offset={1} lg={2} md={3} sm={4} xs={3}>
          <Form.Item label="お得意先様"></Form.Item>
        </Col>
        <Col lg={2} md={3} xs={2}>
          <Form.Item name={'i_tok_cd'}>
            <Input className="clsReadOnly" readOnly={true} />
          </Form.Item>
        </Col>
        <Col xl={1} md={2} xs={2}>
          <Form.Item name={'i_tok_cd2'}>
            <Input className="clsReadOnly" readOnly={true} />
          </Form.Item>
        </Col>
        <Col xxl={5} xl={6} lg={5} md={4} xs={4}>
          <Form.Item name={'i_tok_nm'}>
            <Input className="clsReadOnly" maxLength={20} readOnly={true} />
          </Form.Item>
        </Col>
        <Col offset={1} lg={2} md={3} sm={4} xs={4}>
          <Form.Item label="ログインID"></Form.Item>
        </Col>
        <Col xxl={5} xl={6} lg={5} md={4} sm={3} xs={4}>
          <Form.Item name={'i_compny_nm'}>
            <Input className="clsReadOnly" maxLength={20} readOnly={true} />
          </Form.Item>
        </Col>
        <Col lg={3} sm={3} md={2} xs={2}>
          <Form.Item name={'i_acc_nm'}>
            <Input className="clsReadOnly" maxLength={10} readOnly={true} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default HeaderRow5;
